
import React from 'react';

const Projects: React.FC = () => {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold">My Projects</h1>
      <p>Projects page content...</p>
    </div>
  );
};

export default Projects;
